'use client';

import { ApiKeysPanel } from '@/components/api-keys/api-keys-panel';

export default function ApiKeysPage() {
  return <ApiKeysPanel />;
}
